import type { PricingPackage } from '@/components/sections/PricingTable'
import catalog from '@/content/llms/catalog.json'

export type ServiceSlug =
  | 'strategy'
  | 'growth'
  | 'authority'
  | 'design'
  | 'engineering'
  | 'automation'
  | 'insights'

export type ServiceCatalogEntry = {
  slug: ServiceSlug
  path: string
  name: string
  schemaName: string
  summary: string
  offerings: string[]
  packages: PricingPackage[]
}

const services = catalog.services as ServiceCatalogEntry[]

export function getServicePackages(slug: ServiceSlug): PricingPackage[] {
  const entry = services.find((s) => s.slug === slug)
  if (!entry) {
    throw new Error(`Unknown service slug: ${slug}`)
  }
  return entry.packages
}

export function getService(slug: ServiceSlug): ServiceCatalogEntry {
  const entry = services.find((s) => s.slug === slug)
  if (!entry) {
    throw new Error(`Unknown service slug: ${slug}`)
  }
  return entry
}

export { services as serviceCatalog }
